
import { IoMdBoat } from "react-icons/io"
import { RiHome7Line } from "react-icons/ri"

export const appColor = '#00ADBA'

export const AppIcon = IoMdBoat

export const HomeIcon = RiHome7Line



export const dateFormats = {

    short: {
        name: 'rav.dates_short',
        format: 'd/M/yy'
    },
    medium: {
        name: 'rav.dates_medium',
        format: 'dd/MM/yy'
    },
    full: {
        name: 'rav.dates_full',
        format: 'dd/MM/yyyy'
    }

}

export const imageformats =  [{
        name: 'HD',
        val: 980
    }, {
        name: 'FULL HD',
        val: 1920
    }, {
        name: '2K',
        val: 3840
    }
]
